import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { FiHeart, FiShoppingBag, FiX } from "react-icons/fi";
import { fetchWishlist, removeFromWishlist, clearWishlist } from "../../feature/wishlist";
import { addToCart } from "../../feature/cartSlice";

const formatPrice = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

function Wishlist() {
  const items = useSelector((state) => state.wishlist.items);
  const dispatch = useDispatch();
   console.log(items)
  useEffect(() => {
  dispatch(fetchWishlist());
}, [dispatch]);

  if (items.length === 0) {
    return (
      <div className="min-h-[70vh] pt-[60px] flex items-center justify-center px-4">
        <div className="text-center py-16">
          <FiHeart className="mx-auto text-[64px] text-gray-300" />
          <h2 className="mt-4 text-[22px] sm:text-[26px] font-semibold">
            Your wishlist is empty
          </h2>
          <p className="mt-2 text-gray-500 text-[14px]">
            Tap the heart on any product to save it here.
          </p>
          <Link
            to="/shop"
            className="inline-block mt-6 h-[44px] leading-[44px] px-8 bg-[#2f6b1f]  transition-colors text-white text-[12px] font-bold uppercase tracking-[1px] rounded-[2px]"
          >
            Continue Shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-[60px] bg-[#faf8f6] min-h-screen">
      <div className="w-full max-w-[1240px] mx-auto px-4 py-8 sm:py-12">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h1 className="text-[24px] sm:text-[30px] font-semibold">My Wishlist</h1>
            <p className="text-gray-500 text-[13px] sm:text-[14px]">
              {items.length} {items.length === 1 ? "item" : "items"} saved
            </p>
          </div>
          <button
            onClick={() => dispatch(clearWishlist())}
            className="text-[13px] text-gray-500 hover:text-[#e46a4b] underline"
          >
            Clear wishlist
          </button>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-8 sm:gap-x-5">
          {items.map((item) => (
            <div key={item.id} className="group relative bg-white border border-gray-100 shadow-sm">
              <Link to={`/product/${item.id}`} className="block">
                <div className="w-full aspect-square bg-[#f5f5f7] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-3">
                  <p className="text-[12px] text-[#999] mb-1">{item.category}</p>
                  <h3 className="text-[14px] sm:text-[15px] text-[#111] leading-snug line-clamp-2">
                    {item.name}
                  </h3>
                  <p className="mt-1 text-[14px] font-[600]">{formatPrice(item.price)}</p>
                </div>
              </Link>

              <button
                type="button"
                onClick={() => dispatch(removeFromWishlist(item))}
                aria-label="Remove from wishlist"
                className="absolute top-2 right-2 w-[32px] h-[32px] rounded-full bg-white shadow-md flex items-center justify-center text-[#111] hover:bg-[#2f6b1f] hover:text-white transition-colors"
              >
                <FiX className="text-[16px]" />
              </button>

              <div className="px-3 pb-3">
                <button
                  type="button"
                  onClick={() => {
                    dispatch(
                      addToCart({
                        id: item.id,
                        name: item.name,
                        price: item.price,
                        image: item.img,
                        qty: 1,
                      })
                    );
                    dispatch(removeFromWishlist(item)); // optional: move to cart
                  }}
                  className="w-full h-[38px] flex items-center justify-center gap-2 bg-[#2f6b1f] transition-colors text-white text-[11px] font-bold uppercase tracking-[1px] rounded-[2px]"
                >
                  <FiShoppingBag /> Move to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Wishlist;